module.exports = __webpack_public_path__ + "static/media/la-brands-400.fb598c9c.woff";